/* eslint-disable require-yield,no-console,no-undef */
import { put, takeEvery } from 'redux-saga/effects';

function* progressE() {
    yield put({ type: 'WS_CLOSE', payload: true });
    yield put({ type: 'START_WS', payload: false });
    yield put({ type: 'SCREEN', payload: 'showContact' });
}

function* SagaDisconnect() {
    yield takeEvery('SAGA_DISCONNECT', progressE);
}


export default SagaDisconnect;



// WEBPACK FOOTER //
// ./src/redux/saga/actions/SagaDisconnect.js